// extracted by mini-css-extract-plugin
export default {"container":"SmallLoader_container__OML46","spinner":"SmallLoader_spinner__Sj8LA","spinner-d3wgkg":"SmallLoader_spinner-d3wgkg__gdgYh"};